import { render, staticRenderFns } from "./tag-new.vue?vue&type=template&id=fcd21da8&scoped=true"
import script from "./tag-new.vue?vue&type=script&lang=js"
export * from "./tag-new.vue?vue&type=script&lang=js"
import style0 from "./tag-new.vue?vue&type=style&index=0&id=fcd21da8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd21da8",
  null
  
)

export default component.exports